import McpCard, { type McpItem } from '@/pages/explorer/mcps/McpCard';

interface McpListProps {
  mcps: McpItem[];
  onMcpFavouriteChange: (mcpId: string, isFavorite: boolean) => void;
}

export default function McpList({ mcps, onMcpFavouriteChange }: McpListProps) {
  return (
    <div className="flex flex-col gap-8">
      {mcps.map((mcp) => (
        <McpCard key={mcp.id} mcp={mcp} onMcpFavouriteChange={onMcpFavouriteChange} />
      ))}
    </div>
  );
}
